import axios from 'axios'
import CognitoService from '@/services/CognitoService.js'

//dev
// axios.defaults.baseURL =
// 	'https://k0hu0vcwr8.execute-api.ap-southeast-2.amazonaws.com/dev'

//prod
axios.defaults.baseURL =
	'https://bnhrhq74q4.execute-api.ap-southeast-2.amazonaws.com/prod'

export default {
	async getPosts(job_id, pageSize, exclusivestartkey) {
		await CognitoService.checkTokenExpire()
		const token = sessionStorage.getItem('token')
		return axios.get(
			`/posts/jobid/${job_id}/pagesize/${pageSize}/exclusivestartkey/${exclusivestartkey}`,
			{
				headers: {
					Authorization: `Bearer ${token}`
				}
			}
		)
	},

	async createPost(post) {
		await CognitoService.checkTokenExpire()
		const token = sessionStorage.getItem('token')
		return axios.post(`/posts/createPost`, post, {
			headers: {
				Authorization: `Bearer ${token}`
			}
		})
	}
}
